export const BASIC_DETAILS_LABELS = {
    HEADING: 'Basic Details',
    FOUNDED: 'Founded',
    PAN: 'PAN',
    CIN: 'CIN',
    LLPIN: 'LLPIN',
    GST: 'GST',
    ADDRESS: 'Address',
} as const;
